import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type PosePostPayload = {
  bvhContent: string;
  canvasImageBase64: string;
  characterID?: string;
  duration: number;
  title: string;
};

export default async function postPose(
  projectID: string,
  props: PosePostPayload,
) {
  const { data, error } = await apiRequest<{
    project: ProjectFromAPI;
  }>('mogen-orchestration', `/v2/projects/${projectID}/pose`, {
    method: 'POST',
    body: JSON.stringify(props),
  });

  return {
    data: data ? transformProjectResponse(data.project) : undefined,
    error,
  };
}
